import api from './api';

export const authService = {
  login: async (email, password) => {
    return await api.post('/auth/login', {
      email,
      password
    });
  },
  
  register: async (userData) => {
    return await api.post('/auth/register', userData);
  },
  
  requestPasswordReset: async (email) => {
    return await api.post('/auth/forgot-password', { email });
  },
  
  confirmPasswordReset: async (resetToken, newPassword) => {
    return await api.post('/auth/reset-password', {
      token: resetToken,
      new_password: newPassword
    });
  }
};

export default authService;
